import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import InputText from 'modules/_shared/components/InputText';
import { MessageType } from 'modules/_shared/components/InputMessage';

import { actions } from '../constants/actions';

type Props = {
  action: (typeof actions)[keyof typeof actions];
  name: string;
  cif: string;
  email: string;
  address: string;
  jobTitle: string;
  validEmail: boolean;
  // eslint-disable-next-line no-unused-vars
  handleChangeName: (value: string) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeCif: (value: string) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeEmail: (value: string) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeAddress: (value: string) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeJobTitle: (value: string) => void;
};

const AddBeneficiaryModalPersonalInfoView: FC<Props> = ({
  action,
  name,
  cif,
  email,
  address,
  jobTitle,
  validEmail,
  handleChangeName,
  handleChangeCif,
  handleChangeEmail,
  handleChangeAddress,
  handleChangeJobTitle,
}) => {
  const { t } = useTranslate();

  const isFormDisabled = action === actions.EDIT;

  return (
    <>
      <InputText
        id="beneficiary-name"
        label={t('NameAndSurnameOfTheBenefi')}
        placeholder={t('NameAndSurname')}
        value={name}
        onChange={handleChangeName}
        disabled={isFormDisabled}
        required
      />

      <InputText
        id="beneficiary-identity"
        label={t('NifPassportNie')}
        placeholder={t('NifNoPassportOrDen')}
        tooltip={t('NifPassportNieTooltip')}
        value={cif}
        onChange={handleChangeCif}
        disabled={isFormDisabled}
        minLength={6}
        maxLength={12}
        required
      />

      <InputText
        id="beneficiary-email"
        label={t('BeneficiaryEmail')}
        placeholder={t('EmailOfTheNewBeneficiary')}
        additionalInfo={!validEmail ? t('InvalidEmail') : ''}
        additionalInfoType={!validEmail ? MessageType.ERROR : undefined}
        value={email}
        onChange={handleChangeEmail}
        disabled={isFormDisabled}
        emailInput
        required
      />

      <InputText
        id="beneficiary-address"
        label={t('Address')}
        placeholder={`${t('Address')} (${t('Optional')})`}
        value={address}
        onChange={handleChangeAddress}
        disabled={isFormDisabled}
      />

      <InputText
        id="beneficiary-job"
        label={t('JobTitle')}
        placeholder={t('JobTitleOptional')}
        value={jobTitle}
        onChange={handleChangeJobTitle}
        disabled={isFormDisabled}
      />
    </>
  );
};

export default AddBeneficiaryModalPersonalInfoView;
